import { useState } from "react";
import { Loader2 } from "lucide-react";
import api from "../lib/api";

const inputCls =
  "w-full bg-neutral-900 border border-neutral-700 px-4 py-3 text-sm text-white placeholder-neutral-500 focus:outline-none focus:border-white transition-colors";

export default function AdminLogin({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data.token);
    } catch (err) {
      const detail = err.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen bg-neutral-950 flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm border border-neutral-800 bg-neutral-950 p-8">
        <div className="font-display font-bold text-white text-xl tracking-tight">Künzler &amp; Sauber AG</div>
        <p className="mt-1 text-xs uppercase tracking-[0.25em] text-neutral-500 font-semibold mb-8">Adminbereich</p>
        <div className="space-y-4">
          <input
            data-testid="admin-email"
            type="email"
            required
            placeholder="E-Mail"
            className={inputCls}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <input
            data-testid="admin-password"
            type="password"
            required
            placeholder="Passwort"
            className={inputCls}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{error}</p>}
        <button
          data-testid="admin-login-submit"
          type="submit"
          disabled={loading}
          className="mt-6 w-full bg-white text-neutral-950 font-semibold text-sm py-3 transition-colors hover:bg-neutral-200 disabled:opacity-60 flex items-center justify-center gap-2"
        >
          {loading && <Loader2 size={15} className="animate-spin" />}
          Anmelden
        </button>
        <a href="/" className="mt-5 block text-center text-xs text-neutral-500 hover:text-white transition-colors" data-testid="admin-back-link">
          ← Zurück zur Landingpage
        </a>
      </form>
    </div>
  );
}
